import { useAppConstantsContext } from '@ltvco/refresh-lib/ctx';
import { Modal, Stack, Text } from '@ltvco/refresh-lib/theme';
import {
  BPReward,
  ClickOutPartner,
  Rewards,
  useRewards,
  type Reward,
} from '@ltvco/refresh-lib/v1';
import { useState } from 'react';

// Constant from original PerksPage
const CLICK_OUT_PARTNER_COMPONENT = 'rewards/clickout-partner/widget';

// Modal styles from original PerksPage
const modalStyles = {
  width: '100%',
  margin: 'auto',
  '.MuiDialog-paper': {
    maxWidth: ['90vw', '90vw', '85vw', '1066px'],
    width: ['90vw', '90vw', '85vw', '1066px'],
    margin: 'auto',
  },
};

export const RewardsOffersTab = () => {
  const {
    data: { brandName },
  } = useAppConstantsContext();

  const { data, isLoading } = useRewards();
  const [activeReward, setActiveReward] = useState<string | Reward>('');

  const hasSelectedReward = activeReward !== '';
  const initialRecordSearch = {
    address: '',
    city: '',
    state: '',
    zip_code: '',
  };

  if (isLoading) {
    return <Text>Loading rewards...</Text>;
  }

  return (
    <>
      <Stack spacing={2}>
        <Text variant="h2" fontWeight="bold" fontSize="1.25rem">
          Rewards & Offers
        </Text>
        <Text fontSize="1rem">
          As a {brandName} member, you can take advantage of benefits and perks
          that come with your subscription. Check back often as we add more
          savings - we're just getting started!
        </Text>
        {!!data?.rewards && data?.rewards.length > 0 && (
          <Rewards
            rewards={data?.rewards as BPReward[] | Reward[]}
            activeReward={activeReward}
            hasSelectedReward={hasSelectedReward}
            selectRewardPartner={setActiveReward}
            initialRecordSearch={initialRecordSearch}
          />
        )}
        {data?.rewards?.length === 0 && (
          <Text>No rewards available for this category.</Text>
        )}
      </Stack>

      <Modal
        fullWidth
        hasCloseIcon
        sx={modalStyles}
        open={hasSelectedReward}
        onClose={() => setActiveReward('')}
      >
        {hasSelectedReward && (
          <ClickOutPartner
            reward={activeReward as Reward}
            currentRewardCollapsed={false}
            partnerName={(activeReward as Reward).name}
            selectRewardPartner={() => setActiveReward('')}
            initialRecordSearch={initialRecordSearch}
            isFormReward={
              (activeReward as Reward).component !== CLICK_OUT_PARTNER_COMPONENT
            }
          />
        )}
      </Modal>
    </>
  );
};
